<script>
import axios from 'axios';

export default {
  login(cpf, password, userType) {
    return axios.post('/login', { cpf, password, user_type: userType });
  },
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },
  getDefaultHeaders() {
    return {
      headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
    };
  },
};
</script>
